import { uniqueId } from "lodash";

export const SparkleIcon: React.FC = () => {
  const clipPathId = uniqueId("sparkleicon-clip-");
  const gradient1Id = uniqueId("sparkleicon-gradient-");
  const gradient2Id = uniqueId("sparkleicon-gradient-");
  const gradient3Id = uniqueId("sparkleicon-gradient-");
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      className="h-full w-full"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M59.7902 30.2098C43.4685 30.2098 30.2098 43.4685 30.2098 59.7902C30.2098 59.9161 30.1259 60 30 60C29.8741 60 29.7902 59.9161 29.7902 59.7902C29.7902 43.4685 16.5315 30.2098 0.20979 30.2098C0.0839161 30.2098 0 30.1259 0 30C0 29.8741 0.0839161 29.7902 0.20979 29.7902C16.5315 29.7902 29.7902 16.5315 29.7902 0.20979C29.7902 0.0839161 29.8741 0 30 0C30.1259 0 30.2098 0.0839161 30.2098 0.20979C30.2098 16.5315 43.4685 29.7902 59.7902 29.7902C59.9161 29.7902 60 29.8741 60 30C60 30.1259 59.9161 30.2098 59.7902 30.2098Z"
          fill={`url(#${gradient1Id})`}
        />
        <path
          d="M43.4266 8.18182C47.8322 8.18182 51.3986 4.61538 51.3986 0.20979C51.3986 0.0839161 51.4825 0 51.6084 0C51.7343 0 51.8182 0.0839161 51.8182 0.20979C51.8182 4.61538 55.3846 8.18182 59.7902 8.18182C59.9161 8.18182 60 8.26573 60 8.39161C60 8.51748 59.9161 8.6014 59.7902 8.6014C55.3846 8.6014 51.8182 12.1678 51.8182 16.5734C51.8182 16.6993 51.7343 16.7832 51.6084 16.7832C51.4825 16.7832 51.3986 16.6993 51.3986 16.5734C51.3986 12.1678 47.8322 8.6014 43.4266 8.6014C43.3007 8.6014 43.2168 8.51748 43.2168 8.39161C43.2168 8.26573 43.3007 8.18182 43.4266 8.18182Z"
          fill={`url(#${gradient2Id})`}
        />
        <path
          d="M14.056 51.8182C11.0351 51.8182 8.60149 54.2517 8.60149 57.2727C8.60149 57.3986 8.51758 57.4825 8.3917 57.4825C8.26583 57.4825 8.18191 57.3986 8.18191 57.2727C8.18191 54.2517 5.74835 51.8182 2.72737 51.8182C2.60149 51.8182 2.51758 51.7343 2.51758 51.6084C2.51758 51.4825 2.60149 51.3986 2.72737 51.3986C5.74835 51.3986 8.18191 48.965 8.18191 45.944C8.18191 45.8182 8.26583 45.7343 8.3917 45.7343C8.51758 45.7343 8.60149 45.8182 8.60149 45.944C8.60149 48.965 11.0351 51.3986 14.056 51.3986C14.1819 51.3986 14.2658 51.4825 14.2658 51.6084C14.2658 51.7343 14.1819 51.8182 14.056 51.8182Z"
          fill={`url(#${gradient3Id})`}
        />
      </g>
      <defs>
        <linearGradient
          id={gradient1Id}
          x1="29.9983"
          y1="60.0013"
          x2="29.9983"
          y2="0.00125885"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAE08" />
          <stop offset="1" stopColor="#FCD88E" />
        </linearGradient>
        <linearGradient
          id={gradient2Id}
          x1="51.6084"
          y1="16.7832"
          x2="51.6084"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAE08" />
          <stop offset="1" stopColor="#FCD88E" />
        </linearGradient>
        <linearGradient
          id={gradient3Id}
          x1="8.39128"
          y1="57.4825"
          x2="8.39128"
          y2="45.7343"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAE08" />
          <stop offset="1" stopColor="#FCD88E" />
        </linearGradient>
        <clipPath id={clipPathId}>
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
